"use client"

import Error505 from '@/features/errors/Error-500'

const Error = () => {
  return <Error505 />
}

export default Error